app.controller("ContactFormController",
    ["$rootScope", "$scope", "$http", "$window", "$timeout", function($rootScope, $scope, $http, $window, $timeout) {
		$scope.submitted = false;
		$scope.sendingForm = false;
		var timeout;

		$scope.submitUrl = document.querySelector("link[rel='canonical']").href;

        $scope.submitForm = function() {
			$scope.sendingForm = true;

			if ($scope.scrollToTopOnSubmit && window.Utils && window.Utils.ScrollTo) {
				var scrollTarget = $scope.scrollTarget || '.b-contact-form';

				var formElement = document.querySelector(scrollTarget),
					formTop = formElement.getBoundingClientRect().top;
				if (formTop <= 90) {
					Utils.ScrollTo(scrollTarget, 80);
				}
			}

			if (typeof($scope.$parent.form_agency) != 'undefined') {
				$scope.key = $scope.$parent.form_agency;

				$scope.$watch(function() {
					if (!$scope.$parent.form_agency) {
						$scope.submitted = false;
						$scope.message = '';
					}
				}, $scope.$parent.form_agency);
			}

			$scope.subjects = {
				0: 'Esittelypyyntö kohteesta',
				1: 'Yhteydenottopyyntö verkosta',
				2: 'Kotikäyntipyyntö verkosta' + ($scope.name ? ': '+$scope.name : ''),
				3: 'Kotihakupyyntö verkosta' + ($scope.name ? ': '+$scope.name : '')
			};

			$scope.analyticsEvents = {
				0: 'Ota yhteyttä kohteesta',
				1: 'Ota yhteyttä yleisesti',
				2: 'Tilaa Kotikäynti',
				3: 'Tilaa Kotihaku'
			};
			$scope.adformEvents = {
				0: null,
				1: null,
				2: 'Kotikaynti Laheta',
				3: 'Kotihaku Laheta'
			};

			$scope.subject = $scope.subjects[$scope.subjectIndex];

			var errors = {
				name: 'Syötä nimi',
				postCode: 'Syötä postinumero',
				email: 'Virheellinen sähköpostiosoite',
				phone: 'Syötä puhelinnumero' 
			};
			if ($scope.errors == null) {
				$scope.errors = {};
			}

			

	        var formParams = {
		        name: $scope.name,
		        phone: $scope.phone,
		        email: $scope.email,
		        postCode: $scope.postCode,
		        property: $scope.propertyKey || $scope.key,
		        agent: $scope.agentKey || $scope.key,
		        agency: $scope.agencyKey || $scope.key,
		        subject: $scope.subject,
		        subjectIndex: $scope.subjectIndex,
		        submitUrl: $scope.submitUrl,
		        message: $scope.message,
		        developer: $scope.developer
			};

			if (!formParams.property || location.pathname.indexOf('asuinalue') > -1) {
				formParams.subject = $scope.subjects[1];
			}
			
			if ($scope.agentParameter) { formParams["agentParameter"] = true; }

	        if ($window.wakeTestEmail !== undefined) {
		        formParams.wakeTestEmail = $window.wakeTestEmail;
			}
			
            $http({
                method: "POST",
                url: "/api/km/KMSite/contactForm",
                data: formParams
            })
            .then(function(data) {
				$scope.errors = {};
				$scope.submitted = true;
				$scope.sendingForm = false;

				timeout = setTimeout(function () {
					$scope.name = '';
					$scope.phone = '';
					$scope.email = '';
					$scope.postCode = '';
					$scope.message = '';
					
					$scope.submitted = false;

					$scope.$apply();
				}, 8000);

				if ($scope.newsletter) {
					/* Tilattu uutiskirje */
					// adf.ClickTrack(this, 342679, 'Uutiskirjeen Tilaus',{});
					_gaq.push(['_trackEvent', 'Uutiskirje', 'Lähetä']);
				}
				/* Kotikäynti/Kotihaku omanaan, muuten yleinen yhteydenottolomake */
				/* if ($scope.adformEvents[$scope.subjectIndex] !== null) {
					adf.ClickTrack(this, 342679, $scope.adformEvents[$scope.subjectIndex], {});
				} else {
					adf.ClickTrack(this, 342679, 'Kiinteistomaailma.fi|Yhteydenottolomake', {});
				} */
				_gaq.push(['_trackEvent', $scope.analyticsEvents[$scope.subjectIndex], 'Lähetä']);
            }, 
	        function(results) {
            	$scope.sendingForm = false;

				for(var key in results.data.data) {
					if(!results.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
            });
        };

		$rootScope.focusForm = function () {
			var nameInput = angular.element(document.getElementById('fullNameInput'));
			$("body,html").animate({scrollTop: nameInput.offset().top - 250}, 150);
			$timeout(function() {
				nameInput.focus();
			}, 150);

		};
    }]
);
